import React from "react";
import styled from "styled-components";
import { withLocalize, Translate } from "react-localize-redux";

const Zoom = styled.div`
	transform: scale(${(props) => props.zoom});
	-moz-transform: scale(${(props) => props.zoom});
`;

const ZoomCertificate = (props) => {
	let height = props.height;
	let width = props.width;
	let design = props.design;
	let transform = props.transform;

	const zoomCalculator = (
		maxTargetHeight,
		maxTargetWidth,
		previewHeight,
		previewWidth
	) => {
		let targetRatio = maxTargetWidth / maxTargetHeight;
		let previewRatio = previewWidth / previewHeight;
		if (targetRatio > previewRatio) {
			return maxTargetHeight / previewHeight;
		} else {
			return maxTargetWidth / previewWidth;
		}
	};

	return !props.isBadge ? (
		<Zoom
			style={{
				boxShadow: "0px 5px 5px #00000029",
				transformOrigin: transform ? transform : "",
				backgroundColor: "#ffffff",
			}}
			zoom={zoomCalculator(
				height,
				width,
				design ? design.heightPX : 566,
				design ? design.widthPX : 800
			)}
			className="notranslate"
		>
			<div
				dangerouslySetInnerHTML={{
					__html: design.preview,
				}}
			/>
		</Zoom>
	) : (
		<Zoom
			zoom={zoomCalculator(
				height,
				width,
				design ? design.heightPX : 500,
				design ? design.widthPX : 500
			)}
		>
			<div
				dangerouslySetInnerHTML={{
					__html: design.preview,
				}}
			/>
		</Zoom>
	);
};

export default withLocalize(ZoomCertificate);
